import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/shell/Sidebar";
import { Header } from "@/components/shell/Header";
import { BrainPanel } from "@/features/brain/BrainPanel";

export function AppLayout() {
  return (
    <div className="flex h-screen w-screen overflow-hidden bg-background">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto scrollbar-thin">
          <div className="mx-auto w-full max-w-7xl px-6 py-8 lg:px-10 animate-fade-in">
            <Outlet />
          </div>
        </main>
      </div>
      <BrainPanel />
    </div>
  );
}